<template>
    <div @click.stop="itemClick" :class="{'active':isActive}">
        <slot name="item-second-nav-text"></slot>
    </div>
</template>
<script>
export default {
    props: {
        path: {
            type: String,
        },
        activeStyle: {
            type: String,
            default: "#1b4094",
        },
    },
    data(){
        return {

        }
    },
    methods: {
        itemClick() {
            this.$router.push(this.path);
            document.documentElement.scrollTop = 0;
        },
    },
    computed: {
        isActive() {
            return this.$route.path.indexOf(this.path) !== -1;
        },
    },
}
</script>
<style lang="less" scoped>
div{
    p {
        text-align: center;
        font-size: 14px;
        font-family: "Microsoft YaHei";
        line-height: 2.286;
        color: #242424;
    }
    p:hover {
        color: rgb(19, 61, 147);
    }
}
div.active {
    p{
        color: rgb(19, 61, 147);
    }
}
</style>
